export default "__VITE_ASSET__DcTuWcdk__"